import { createHashRouter } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { InstitutionEditorPage } from "./pages/InstitutionEditorPage";
import { InstitutionPage } from "./pages/InstitutionPage";
import { Institutions } from "./pages/Institutions";
import { ProfessorPanel } from "./pages/ProfessorPanel";
import { ProjectEditorPage } from "./pages/ProjectEditorPage";
import { ProjectPage } from "./pages/ProjectPage";
import { PublicationPage } from "./pages/PublicationPage";
import { PublicMetrics } from "./pages/PublicMetrics";
import RegisterProfessor from "./pages/RegisterProfessor";
import { Repository } from "./pages/Repository";
import { StudentDashboard } from "./pages/StudentDashboard";

export const router = createHashRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "instituicoes",
        element: <Institutions />,
      },
      {
        path: "repositorio",
        element: <Repository />,
      },
      {
        path: "metricas-publicas",
        element: <PublicMetrics />,
      },
      {
        path: "professor",
        element: <ProfessorPanel />,
      },
      {
        path: "aluno",
        element: <StudentDashboard />,
      },
      {
        path: "professor/instituicoes/nova",
        element: <InstitutionEditorPage />,
      },
      {
        path: "professor/instituicoes/:id/editar",
        element: <InstitutionEditorPage />,
      },
      {
        path: "professor/projetos/novo",
        element: <ProjectEditorPage />,
      },
      {
        path: "professor/projetos/:id/editar",
        element: <ProjectEditorPage />,
      },
      {
        path: "projetos/:slug",
        element: <ProjectPage />,
      },
      {
        path: "/institutions/:slug",
        element: <InstitutionPage />,
      },
      {
        path: "/publicacao/:id",
        element: <PublicationPage />,
      },
    ],
  },
  {
    path: "register-professor",
    element: <RegisterProfessor />,
  },
]);
